import { HeaderGroup } from "react-table";

export const useSortValues = (
  headerGroups: HeaderGroup<any>[]
): { sortableIds: string[]; sortedBy: HeaderGroup<any> } => {
  const headers: HeaderGroup<any>[] = headerGroups[0]
    ? headerGroups[0].headers
    : [];
  const getCurrentSorted = (column: HeaderGroup<any>) => column.isSorted;
  const getSortableIDs = (column: HeaderGroup<any>): boolean => column.canSort;
  const extractId = (column: HeaderGroup<any>): string => column.id;

  const sortableIds = headers.filter(getSortableIDs).map(extractId);
  const sortedBy = headers.find(getCurrentSorted);

  return {
    sortableIds,
    sortedBy,
  };
};
